import axiosClient from "../axios-client";
import { toastMessage } from "../toaster/toaster";
import { changeLoaderStatus } from "./loaderAction";


// ===============================================================================
// =================================== GET API ===================================
// ===============================================================================


export const getReportTypes = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/report/report-types`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Report types not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


export const getOrderedReports = async (dispatch) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .get(`/report/ordered-reports`)
        .then((res) => {
            return res?.data
        })
        .catch((error) => {
            toastMessage("Ordered reports not found", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};


// ===============================================================================
// =================================== POST API ===================================
// ===============================================================================


export const createReport = async (dispatch, data) => {
    changeLoaderStatus(dispatch, true)
    return axiosClient
        .post(`/report/create-report`, data)
        .then((res) => {
            toastMessage("Report created successfully", "success")
        })
        .catch((error) => {
            toastMessage("Report not created, due to some error", "error")
            throw error;
        })
        .finally(() => {
            setTimeout(() => {
                changeLoaderStatus(dispatch, false)
            }, 500);
        })
};
